import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white" data-id="element-18" data-mp="vtnxirotfgtu">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-19" data-mp="qu2xsf1tn4g2">
        <Reveal className="text-center" data-id="element-20" data-mp="qvw7k37qe4sa">
          <h2 id="bonos" className="font-display text-lg uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-21" data-mp="14t2jbdu1f380">
            🎁 Y además recibes 5 bonos
          </h2>
        </Reveal>

        <ul className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1ei2ndbnecot2">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-2 border-gold/40 bg-mist p-3" data-id="element-23" data-mp="19kszw1jkin7v" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-condensed text-base uppercase leading-tight tracking-wide text-navy sm:text-lg" data-id="element-24" data-mp="1jkbfk5sg3mu4">
                <GiftIcon size={15} className="mt-1 flex-shrink-0 text-gold" strokeWidth={2.5} data-id="element-25" data-mp="3trnmnsaim2el" />
                🎁 {bono.title}
              </h3>
              <p className="mt-1 font-body text-[0.76rem] leading-snug text-steel sm:text-[0.8rem]" data-id="element-26" data-mp="7kz008x2knxn">
                {bono.desc}
              </p>
              <div className="mt-auto flex items-center justify-between gap-2 border-t border-navy/10 pt-2" data-id="element-27" data-mp="chpfov4yphij">
                <span className="text-[0.72rem] text-steel line-through sm:text-[0.76rem]" data-id="element-28" data-mp="gj0yagpf52h8">
                  Valor: {bono.value}
                </span>
                <span className="rounded-md bg-solar px-2 py-0.5 text-[0.66rem] font-black uppercase text-coal sm:text-[0.7rem]" data-id="element-29" data-mp="q9vkjl2o022o">
                  🔥 Hoy: Gratis
                </span>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-solar bg-coal p-3 text-center" data-id="element-30" data-mp="1079xhapdq8q8">
            <p className="font-condensed text-base uppercase leading-tight tracking-wide text-solar sm:text-lg" data-id="element-31" data-mp="5kb76sjc9ffz">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="font-display text-3xl text-white line-through decoration-solar decoration-2 sm:text-4xl" data-id="element-32" data-mp="fj0punj273xa">
              {BONUS_VALUE}
            </p>
            <p className="mt-1 font-condensed text-lg uppercase tracking-wide text-solar sm:text-xl" data-id="element-33" data-mp="odf3ymrus8et">
              🔥 Hoy los recibes gratis con tu compra
            </p>
          </Reveal>
        </ul>

        <Reveal delay={0.2} className="mt-3 flex justify-center" data-id="element-34" data-mp="yajsuud32hzb">
          <CtaButton size="lg" data-id="element-35" data-mp="3519inymd3mvb">
            🔥 ¡SÍ! QUIERO EL SISTEMA COMPLETO POR $19.990
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}